export default "__VITE_ASSET__7EQOUMjL__"